import {Component, Input} from '@angular/core';
import {ExportService} from 'src/app/services/export.service';

/**
 * This component is added to the table and shows the "Generate excel report" button.
 */
@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss'],
})
export class ExportComponent {
  isSendReportClicked = false;
  /**
   * Data that needs to be exported
   */
  @Input() content: any = '';
  @Input() headers!: string[];

  constructor(private exportService: ExportService) {}

  download(headerList?: string[]) {
    this.exportService.downloadFile(this.content, 'exported', headerList);
  }
}
